<div class="mt-3 max-w-md mx-auto  md:max-w-4xl p-3">
  <div class="flex flex-col items-center">
    <img src="../assets/images/logo/logo-large.png" alt="Logo-jfl" class="logo">
    <h1 class="text-3xl font-bold text-gray-600 pt-3 pl-3">Ficha Cadastral</h1>
  </div>
  <router-outlet></router-outlet>
</div>
